<template>
  <v-dialog
    fullscreen
    :value='value'
    :transition="transition"
    @input='handleInput'
    :persistent='!closeable'
  >
    <template v-slot:default>
      <div class='root-container'>

        <v-container class="fill-height py-0">
          <v-card flat class='d-flex flex-column fill-height card'> 
            <v-toolbar dense flat color='transparent' class='flex-grow-0'>
              <dark-mode-switch/>
              <image-switch v-if="imageSrc" />
              <slot name='top-tools-prepend'/>
              <v-spacer></v-spacer>
              <slot name='top-tools-append'/>
              <close-button v-if='closeable' @close="handleInput"/>
            </v-toolbar>
            <slot></slot>
            <v-card-actions class="justify-end align-center">
              <slot name='actions'><text-to-speech-global/></slot>
            </v-card-actions>
          </v-card>
        </v-container>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import { defineComponent, inject } from 'vue'
import TextToSpeechGlobal from './tts/TextToSpeechGlobal.vue';
import DarkModeSwitch from './darkModeSwitch.vue';
import ImageSwitch from './ImageSwitch.vue';
import CloseButton from './CloseButton.vue';

export default defineComponent({
  components: {
    TextToSpeechGlobal,
    DarkModeSwitch,
    ImageSwitch,
    CloseButton
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    transition: {
      type: String,
      default: 'dialog-bottom-transition'
    },
    closeable: {
      type: Boolean,
      default: true
    }
  },
  setup(_,context){
    const imageSrc = inject('imageSrc')
    const handleInput = (val)=>{
      context.emit('input', val)
    }
    return {
      imageSrc,
      handleInput
    }
  }
})
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  overflow: hidden;
}
.root-container {
  width: 100%;
  height: 100%;
}
</style>
